module.exports = __webpack_public_path__ + "media/images/close-6278f5323d595afda4536cef6bdf5eac.svg";